import request from "_private/utils/request";

export function FetchFindPassRateChart(data) {
    return request({
        url: "/report/MonitorInfo/findPassRateChart",
        method: "post",
        data
    });
}

// 企业合格率排行列表
export function FetchFindComparyPassRateByPage(data) {
    return request({
        url: "/report/companyQualifyRateRanking/findByPage",
        method: "post",
        headers: {type: "json"},
        data
    });
}

/**
 * 企业合格率排行列表导出
 * @param {*} data
 */
export function exportListByComparyPassRate(data) {
    return request({
        url: "/base/compary/findByPage",
        method: "post",
        data
    });
}

// 区域湿度合格率
export function FetchFindAreaHumPassRateByPage(data) {
    return request({
        url: "/base/compary/findByPage",
        method: "post",
        data
    });
}
